import Swiper from 'swiper/bundle';

const rsCarousel = {
    init: (carousels) => {
        carousels.forEach(carousel => {
            const swiperOptions = {};
            const loop = carousel.dataset.loop;
            const autoplay = carousel.dataset.autoplay;
            const pagination = carousel.dataset.pagination;
            const slidesper = carousel.dataset.slidesper;
            const effect = carousel.dataset.effect;
            // const navigation = carousel.dataset.navigation;

            if (slidesper) {
                swiperOptions.centeredSlides = false;
                const perView = carousel.dataset.slidesperdesktop;
                const perViewMobile = carousel.dataset.slidespermobile;
                const perViewTablet = carousel.dataset.slidespertablet;

                swiperOptions.slidesPerView = perViewMobile || 1;

                if (perViewMobile && perViewTablet) {
                    swiperOptions.breakpoints = {
                        576: {
                            slidesPerView: perViewTablet,
                        },
                        960: {
                            slidesPerView: perView,
                        },
                    };
                }
            } else {
                swiperOptions.effect = 'slide';
                swiperOptions.slidesPerView = 1;
            }

            if (loop) {
                swiperOptions.loop = true;
            }

            if (autoplay) {
                swiperOptions.autoplay = {
                    delay: autoplay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                };
            }

            const containerID = '#' + carousel.closest('.block').id;

            if (pagination) {
                swiperOptions.pagination = {
                    el: containerID + ' .swiper-pagination',
                    clickable: true,
                };
            }

            if (effect) {
                swiperOptions.effect = 'slide';
            }

            swiperOptions.navigation = {
                nextEl: containerID + ' .swiper-next-prev__prev',
                prevEl: containerID + ' .swiper-next-prev__next',
            };

            // eslint-disable-next-line no-unused-vars
            const swiper = new Swiper(`#${carousel.getAttribute('id')}`, swiperOptions);

            if (!slidesper) {
                const activeCount = document.querySelector(`#${carousel.id} .swiper-slide-count__active`);
                const totalCount = document.querySelector(`#${carousel.id} .swiper-slide-count__total`);

                const generateSlideCounter = (active, total) => {
                    const slides = Array.from(document.querySelectorAll(`#${carousel.id} .swiper-slide`));
                    const slidesCount = [];

                    slides.forEach((slide) => {
                        if (!slide.classList.contains('swiper-slide-duplicate')) {
                            slidesCount.push(slide);
                        }
                    });
                };

                generateSlideCounter(activeCount, totalCount);
            }
        });
    },
};

export default rsCarousel;
